export const isValidEmail = (email: string) =>
  email ? /\S+@\S+\.\S+/.test(email) : false;
